import { useDispatch } from "react-redux";
import axiosService from "../axios";
import { AxiosError, AxiosResponse } from "axios";
import { useState } from "react";
import { encryptAndStoreValueToLocalStorage, getDecryptedValueFromLocalStorage } from "../methods/localStorageBasedMethods";
import { OrderPadLine } from "../../store/OrderPad";


const useFetchAndSetRealitexOrderNo = () => {

  //data from local storage  
  const loggedInContactId = getDecryptedValueFromLocalStorage('ecommContactIdEnc');    

  const dispatch = useDispatch(); //Dispatcher for Order store


  const fetchFromApiAndStoreNextRealitexOrderNumber = async (customerRef: string) => {

    //check if there is a current order no, if not - gfo get one and store it in local storage
    const currentOrderNo = getDecryptedValueFromLocalStorage(`order-pad-order-no:${loggedInContactId}Enc`);
    if(!currentOrderNo || currentOrderNo === '-1'){
      try{
        await axiosService
          .post(
            `api/v1/StockPieceAllocation/getnextordernumber?customerRef=${customerRef}`
          )
          .then((response : AxiosResponse<number>) => {
            const { data } = response;

            dispatch({type: 'SET_CURRENTLY_CONSTRUCTING_ORDER_NO', currentlyConstructingOrderNo: data}); //calling this also stores it to local storage 
          })
          .catch((error: AxiosError) => {
            //No error toast, silently fail, update setState and Redux to '-1' so that the different areas of the program that use this know an attempt to get it has been made but failed
            dispatch({type: 'SET_CURRENTLY_CONSTRUCTING_ORDER_NO', currentlyConstructingOrderNo: -1}); //calling this also stores it to local storage
          })
      }
      catch(error: any){
         //No error toast, silently fail, update setState and Redux to '-1' so that the different areas of the program that use this know an attempt to get it has been made but failed
         dispatch({type: 'SET_CURRENTLY_CONSTRUCTING_ORDER_NO', currentlyConstructingOrderNo: -1}); //calling this also stores it to local storage
        //setCurrentlyConstructingOrderNo('-1');
      }
    }
  }




  const fetchFromApiAndStoreNextRealitexUnpayableOrderNumber = async (customerRef: string) => {

    //check if there is a current order no, if not - gfo get one and store it in local storage
    const currentlyConstructingNonPayableOrderNoFromLocalStorage = getDecryptedValueFromLocalStorage(`order-pad-unpayable-order-no:${loggedInContactId}Enc`);
    if(!currentlyConstructingNonPayableOrderNoFromLocalStorage || currentlyConstructingNonPayableOrderNoFromLocalStorage === '-1' || currentlyConstructingNonPayableOrderNoFromLocalStorage === '0'){
      try{
        await axiosService
          .post(
            `api/v1/StockPieceAllocation/getnextordernumber?customerRef=${customerRef}`
          )
          .then((response : AxiosResponse<number>) => {
            const { data } = response;
           
              dispatch({type: 'SET_CURRENTLY_CONSTRUCTING_UNPAYABLE_ORDER_NO', currentlyConstructingUnpayableOrderNo: data}); //calling this also stores it to local storage
  
          })
          .catch((error: AxiosError) => {
            //No error toast, silently fail, update setState and Redux to '-1' so that the different areas of the program that use this know an attempt to get it has been made but failed
              dispatch({type: 'SET_CURRENTLY_CONSTRUCTING_UNPAYABLE_ORDER_NO', currentlyConstructingUnpayableOrderNo: -1}); //calling this also stores it to local storage
          })
      }
      catch(error: any){
         //No error toast, silently fail, update setState and Redux to '-1' so that the different areas of the program that use this know an attempt to get it has been made but failed
         dispatch({type: 'SET_CURRENTLY_CONSTRUCTING_UNPAYABLE_ORDER_NO', currentlyConstructingUnpayableOrderNo: -1}); //calling this also stores it to local storage
      }
    }
  }

    return {fetchFromApiAndStoreNextRealitexOrderNumber, fetchFromApiAndStoreNextRealitexUnpayableOrderNumber};

}; export default useFetchAndSetRealitexOrderNo;


export const getNextRealitexOrderLineNo = () => {
  const loggedInContactId = getDecryptedValueFromLocalStorage('ecommContactIdEnc');
  let orderLinesAsSerialisableString = getDecryptedValueFromLocalStorage(`order-pad-lines:${loggedInContactId}Enc`);
  const  linesPulledFromLocalStorage : OrderPadLine[] = orderLinesAsSerialisableString ? JSON.parse(orderLinesAsSerialisableString) : [];
  return linesPulledFromLocalStorage.length + 1;
}

export const getNextRealitexUnallocatableOrderLineNo = () => {
  const loggedInContactId = getDecryptedValueFromLocalStorage('ecommContactIdEnc');
  const unpayableOrderLinesAsSerialisableString = getDecryptedValueFromLocalStorage(`order-pad-unpayable-lines:${loggedInContactId}Enc`);
  const  unpayableOrderLinesPulledFromLocalStorage : OrderPadLine[] = unpayableOrderLinesAsSerialisableString ? JSON.parse(unpayableOrderLinesAsSerialisableString) : [];
  return unpayableOrderLinesPulledFromLocalStorage.length + 1;
}